import { Builder } from 'path-shared/models/builder';
import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from 'path-shared/models/dictionary';
import { TextoAviso } from '../../model/texto-aviso';

@Component({
  selector: 'app-texto-aviso-editor',
  templateUrl: './texto-aviso-editor.component.html',
  styleUrls: ['./texto-aviso-editor.component.scss']
})
export class TextoAvisoEditorComponent implements OnInit {

  _currentEditing: boolean;
  @Input() get currentEditing() {
    return this._currentEditing;
  } set currentEditing(val: any) {
    this._currentEditing = val;
  }

  _currentTexto: TextoAviso;
  @Input() get currentTexto() {
    return this._currentTexto;
  } set currentTexto(val) {
    if (val !== undefined && val !== null) {
      this._currentTexto = val;
    } else {
      this.currentTexto = Builder.newTextoAviso();
    }
  }

  @Input() idiomaDictionary: Array<Dictionary>;

  constructor() {
    this.currentTexto = Builder.newTextoAviso();
    this.currentEditing = false;
    this.idiomaDictionary = new Array();
  }

  ngOnInit() { }

  textoFormatadoChanged(newText: string): void {
    this.currentTexto.htmlValue = newText;
  }

  siglaSeleccionada(sigla: any): void {
    this.currentTexto.idioma = sigla;
  }

  changeLogInBlock(loginLock: any) {
    this.currentTexto.permiteLogIn = !loginLock;
  }

}
